module.exports = __webpack_public_path__ + "static/media/configuration.f5d986fb.svg";